// Search
function faqDdm() {
    $('.list-type-4 .ddm').dropDownMenu({
        disabled:    false,
        classBtn:    '',
        independent: true
    });
}
